<tr class="table-overflow-container">
  <div *ngIf="isLoading; else elseBlock" class="app-loading">
    <svg class="spinner" viewBox="25 25 50 50">
      <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="3" stroke-miterlimit="10"/>
    </svg>
  </div>
  <ng-template #elseBlock>
    <table mat-table [dataSource]="duplicateDetailsList"
           id="duplicate-list" class="table-striped">
      <ng-container matColumnDef="checkbox_n_master" sticky>
        <th mat-header-cell *matHeaderCellDef class="mat-column-checkbox"> <!-- checkboxes -->
            <div class="kyloe-checkbox-select-all">
                <input type="checkbox" id="{{ this.masterDuplicatesData.duplicateTableEntry.masterID }}"
                       [checked]="isAllSelected()" (change)="$event ? toggleAll() : null" value="none">
                <label for="{{ this.masterDuplicatesData.duplicateTableEntry.masterID }}"></label>
            </div>
            <div id="multi-select-dropdown">
                <button mat-button [matMenuTriggerFor]="aboveMenu" class="select-options" *ngIf="this.selectedDuplicates.hasValue()"
                        [ngClass]="!this.selectedDuplicates.isEmpty() ? 'select-all-show dropdown-toggle' : ''">
                    {{ this.selectedDuplicates.selected.length }} Selected
                </button>
                <mat-menu #aboveMenu="matMenu">
                    <button mat-menu-item (click)="mergeSelected()">Merge</button>
                    <button mat-menu-item (click)="markSelectedAsNotDuplicate()">Remove selected Duplicate{{this.selectedDuplicates.selected.length > 1 ? 's' : ''}}</button>
                </mat-menu>
            </div>
        </th>
        <td mat-cell *matCellDef="let duplicateDetails" class="select-row"> <!-- checkboxes -->
          <div class="paired-table-data">
            <div class="kyloe-checkbox">
              <input type="checkbox" id="{{duplicateDetails.bullhornID}} + 10" value="{{duplicateDetails.bullhornID}}"
                     (change)="$event ? selectedDuplicates.toggle(duplicateDetails) : null"
                     [checked]="selectedDuplicates.isSelected(duplicateDetails)">
              <label for="{{duplicateDetails.bullhornID}} + 10"></label>
            </div>
            <button (click)="setNewMaster(duplicateDetails)" class="btn btn-info" appRipple>Set Master </button>
          </div>
        </td>
      </ng-container>
        <ng-container matColumnDef="checkbox_n_master-master" sticky>
            <th mat-header-cell *matHeaderCellDef class="mat-column-checkbox" class="master-header"></th>
        </ng-container>
        <ng-container matColumnDef="id" sticky>
            <th mat-header-cell *matHeaderCellDef>ID</th>
            <td mat-cell *matCellDef="let duplicateDetails"> <!-- id -->
                <a (click)="utilsService.openBullhornRecord(duplicateDetails.bullhornID,this.mergingEntity)">{{ duplicateDetails.bullhornID }}</a>
            </td>
        </ng-container>
      <ng-container matColumnDef="id-master" sticky>
        <th mat-header-cell *matHeaderCellDef class="master-header">
          <a (click)="utilsService.openBullhornRecord(masterData.bullhornID,this.mergingEntity)">{{ masterData.bullhornID }}</a>
        </th>
      </ng-container>
      <ng-container matColumnDef="name" sticky>
        <th mat-header-cell *matHeaderCellDef>Name</th>
        <td mat-cell *matCellDef="let duplicateDetails">
          <div *ngIf="duplicateDetails.bullhornID === masterData.bullhornID; else notMasterName" class="master">
            <div class="small">Master Entry</div>
            <div> {{ masterData.firstName ? masterData.firstName + " " + masterData.lastName : masterData.name }} </div>
          </div>
          <ng-template #notMasterName>
            <div> {{ duplicateDetails.firstName ? duplicateDetails.firstName + " " + duplicateDetails.lastName : duplicateDetails.name }} </div>
          </ng-template>
        </td>
      </ng-container>
        <ng-container matColumnDef="name-master" sticky>
            <th mat-header-cell *matHeaderCellDef class="master-header">
                <div class="master">
                    <div id="master-entry" class="small">Master Entry</div>
                    <div> {{ masterData.firstName ? masterData.firstName + " " + masterData.lastName : masterData.name }} </div>
                </div>
            </th>
        </ng-container>
      <ng-container *ngFor="let f of fieldList; let colIndex = index" matColumnDef="{{f.field}}">
        <th mat-header-cell *matHeaderCellDef>
          {{f.label}}
        </th>
        <td mat-cell *matCellDef="let duplicateDetails">
          <span *ngIf="f.dataType == 'date'; else elseBlock1">
              <span [matTooltip]="duplicateDetails[f.field] | date: 'dd MMMM yyyy HH:mm:ss' : 'UTC' + ' UTC'" matTooltipShowDelay="500">
              {{duplicateDetails[f.field] | date: 'dd MMMM yyyy' }}
              </span>
          </span>
          <ng-template #elseBlock1>
            <span *ngIf="f.dataType === 'ID'; else elseBlock2">
                {{duplicateDetails[f.complex[0]]}} (ID {{duplicateDetails[f.complex[1]]}})
            </span>
          </ng-template>
          <ng-template #elseBlock2>
            {{duplicateDetails[f.field]}}
          </ng-template>
        </td>
      </ng-container>
        <ng-container *ngFor="let f of fieldList; let colIndex = index" matColumnDef="{{f.field+'-master'}}">
            <th mat-header-cell *matHeaderCellDef class="master-header">
          <span *ngIf="f.dataType == 'date'; else elseBlock1">
              <span [matTooltip]="masterData[f.field] | date: 'dd MMMM yyyy HH:mm:ss' : 'UTC' + ' UTC'" matTooltipShowDelay="500">
              {{masterData[f.field] | date: 'dd MMMM yyyy' }}
              </span>
          </span>
                <ng-template #elseBlock1>
            <span *ngIf="f.dataType === 'ID'; else elseBlock2">
                {{masterData[f.complex[0]]}} (ID {{masterData[f.complex[1]]}})
            </span>
                </ng-template>
                <ng-template #elseBlock2>
                    {{masterData[f.field]}}
                </ng-template>
            </th>
        </ng-container>
      <ng-container matColumnDef="additional{{i+1}}" *ngFor="let field of additionalReportFields; index as i" >
        <th mat-header-cell *matHeaderCellDef [matTooltip]="additionalReportFieldTooltip" class="additionalField">
          {{ field }}
        </th>
        <td mat-cell *matCellDef="let duplicateDetails">
          {{ duplicateDetails[field] }}
        </td>
      </ng-container>
        <ng-container matColumnDef="additional{{i+1}}+'-master'" *ngFor="let field of additionalReportFields; index as i" class="master-header" >
            <th mat-header-cell *matHeaderCellDef [matTooltip]="additionalReportFieldTooltip" class="additionalField">
                {{ field + " - " + masterData[field] }}
            </th>
        </ng-container>
      <tr mat-header-row *matHeaderRowDef="this.headerColumns; sticky: true"></tr>
      <tr mat-header-row class="master-header" *matHeaderRowDef="this.masterRowHeaderColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: headerColumns;"></tr>
    </table>
  </ng-template>
</tr>
<mat-paginator [pageSize]="25" [pageSizeOptions]="[5, 10, 25]" [selectConfig]="pageSizeSelectConfig"></mat-paginator>
